import { render, staticRenderFns } from "./ShiftRoutePage.vue?vue&type=template&id=6058c4f8"
import script from "./ShiftRoutePage.vue?vue&type=script&lang=js"
export * from "./ShiftRoutePage.vue?vue&type=script&lang=js"
import style0 from "./ShiftRoutePage.vue?vue&type=style&index=0&id=6058c4f8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports